import Vue from "vue";
import Router from "vue-router";
import top from "@/pages/top";
import reservation from "@/pages/reservation";
import cancel from "@/pages/cancel";
import add from "@/pages/add";
//import confirm from '@/pages/confirm'
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "top",
      component: top,
    },
    {
      path: "/reservation",
      name: "reservation",
      component: reservation,
    },
    // {
    //   // Analyticsのトランザクション操作用
    //   path: "/addapter-admin/cancel",
    //   name: "cancel",
    //   component: cancel,
    // },
    // {
    //   path: "/addapter-admin/add",
    //   name: "add",
    //   component: add,
    // },
  ],
});
